import { atom } from 'recoil';

import { RECOIL_ATOM_KEYS } from '../recoilKey';

export const userDataUpdateFlagState = atom({
  key: RECOIL_ATOM_KEYS.USER_DATA_UPDATE_FLAG, // unique ID (with respect to other atoms/selectors)
  default: false, // default value (aka initial value)
});
